<template>
  <!-- APP BAR -->
  <TheAppBar
    v-model:support-panel="supportPanel"
    :hide-app-switch="hideAppSwitch"
    :is-mobile="device?.isMobile"
  />
  <!-- /APP BAR -->

  <DeepSupportPanel v-model="supportPanel" />

  <v-main class="bg-background-grey" fullscreen>
    <slot>
      <ContainerContentOrError>
        <router-view />
      </ContainerContentOrError>
    </slot>
  </v-main>
</template>

<script lang="ts" setup>
import { DeviceKey } from '@/plugins/device-detector-js.ts'
import { useKeycloak } from '@/composables/auth/keycloak'
import TheAppBar from '@/components/appbar/TheAppBar.vue'
import ContainerContentOrError from '@/components/containers/ContainerContentOrError.vue'
import DeepSupportPanel from '@/components/DeepSupportPanel.vue'

const device = inject(DeviceKey)

const { isAuthenticated } = useKeycloak()
const hideAppSwitch = computed(() => !isAuthenticated.value)

const supportPanel = ref(false)
</script>
